var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticStyle: { height: "120px" } }),
    _c("div", { staticClass: "box_foot" }, [
      _c(
        "div",
        { staticClass: "box_foot_title", staticStyle: { "font-size": "16px" } },
        [
          _c("div", { staticStyle: { "margin-right": "40px" } }, [
            _vm._v("客服邮箱：" + _vm._s(_vm.configdata.maile)),
          ]),
          _c("div", [
            _vm._v(
              "联系电话：" +
                _vm._s(_vm.configdata.servicephone) +
                " 工作日：9:00-18:00"
            ),
          ]),
        ]
      ),
      _c("div", { staticClass: "box_foot_line" }),
      _c("div", { staticClass: "box_foot_content" }, [
        _c("div", { staticClass: "box_foot_content_banquan" }, [
          _vm._v("Copyright © 2010-2023 华道艾腾 ALL Rights Reserved 版权所有"),
        ]),
        _c(
          "div",
          {
            staticClass: "box_foot_content_beian",
            staticStyle: { "margin-left": "60px" },
          },
          [
            _c(
              "a",
              {
                staticStyle: { "font-size": "14px", color: "#fff" },
                attrs: {
                  target: "_blank",
                  href: "https://beian.miit.gov.cn/#/Integrated/index",
                },
              },
              [
                _vm._v(
                  " 工信部备案号：" + _vm._s(_vm.configdata.sitebeian) + " "
                ),
              ]
            ),
            _c("img", {
              staticClass: "box_foot_content_beian_police",
              attrs: { src: _vm.police },
            }),
            _c(
              "a",
              {
                staticStyle: { "font-size": "14px", color: "#fff" },
                attrs: {
                  target: "_blank",
                  href:
                    "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=" +
                    _vm.configdata.policebeiant,
                },
              },
              [
                _vm._v(
                  " 公安备案号： " + _vm._s(_vm.configdata.policebeiansn) + " "
                ),
              ]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }